import MarkdownLink from "@common/components/MarkdownLink";
import ReactMarkdown from "react-markdown";
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";
import styles from './index.module.scss';

export const Markdown = ({content}: {content: string}) => {
    return (
        <div className={styles.markdown}>
            <ReactMarkdown
                remarkPlugins={[remarkBreaks, remarkGfm]}
                components={{
                    code({
                        node, className, children, ...props 
                    }: any) {
                        const match = /language-(\w+)/.exec(className || '')
                        return match ? (
                            <SyntaxHighlighter
                                {...props}
                                style={vscDarkPlus}
                                language={match[1]}
                                PreTag="div"
                                customStyle={{ borderRadius: '8px' }}
                            >
                                {String(children).replace(/\n$/, '')}
                            </SyntaxHighlighter>
                        ) : (
                            <code {...props} className={className}>
                                {children}
                            </code>
                        )
                    },
                    a: ({ node, ...props }) => (
                        <MarkdownLink 
                            {...props} 
                            href={props.href || '#'}
                        />
                    ),
                    table: ({ node, ...props }) => (
                        <div className={styles.tableContainer}>
                            <table {...props} />
                        </div>
                    ),
                }}
            >
                {content}
            </ReactMarkdown>
        </div>
    )
}